import style from "./style.module.scss";
import MainSharedComponent from "../mainSharedComponent";
import { DomainInfo } from "@components/severalbrands/utils/services";
const list = [
    {
        img: "/severalbrands/assets/images/visionaryBehindImg2.png",
        mainTitle: "Decades of Experience",
        paragraphs: [
            "Our founders have spent decades learning what does and doesn't work in lead generation, and we've built that experience into a layered verification process: automated checks that flag suspicious entries, followed by manual review for fraud and compliance. We don't rely on scraped contact lists, only leads generated through our own properties.",
        ],
        mainSectionClassName: `3xl:gap-[150px] lg:gap-[100px] gap-[20px]`,
        mainTitleClassName: "text-[#351C4F]",

        imgClassName:
            "w-[270px]  h-[200px] md:w-[390px] md:min-w-[390px] md:h-[237px] 3xl:w-[590px] 3xl:min-w-[590px] 3xl:h-[437px] relative ",
    },
    {
        img: "/severalbrands/assets/images/dedicatedToBuilding2.png",
        mainTitle: "Vertical-Specific Expertise",
        paragraphs: [
            "With specialists across legal, B2B and software, auto warranty, and more, we build campaigns that speak directly to the needs of each industry, blending SEO, paid ads, and content strategy tailored to how each audience actually makes decisions.",
        ],
        mainSectionClassName: `3xl:gap-[250px] lg:gap-[200px] gap-[20px]`,

        mainTitleClassName: "text-[#351C4F] 3xl:mt-12",
        imgToLeft: true,
        imgClassName:
            "w-[260px]  h-[200px] md:w-[378px] md:min-w-[378px] md:h-[245px] 3xl:w-[578px] 3xl:min-w-[578px] 3xl:h-[445px] relative ",
    },
];

export default function SecondSection({
    domainInfo,
}: {
    domainInfo: DomainInfo;
}) {
    return (
        <section className={`${style["mainContainer"]}`}>
            {list.map((el, index) => (
                <div className="lg:mt-32 mt-16 first-of-type:mt-0" key={index}>
                    <MainSharedComponent info={el} domainInfo={domainInfo} />
                </div>
            ))}
        </section>
    );
}
